export const ALLOCATIONS = 'ALLOCATIONS'
export const PROJECTS_DATA = 'PROJECTS_DATA'
export const PROJECTS_LIST = 'PROJECTS_LIST'
export const PROJECTS_TASK_LIST = 'PROJECTS_TASK_LIST'
export const FILTER_DATA = 'FILTER_DATA'
export const SET_FILTERS_OPTIONS_PROJECTS = 'SET_FILTERS_OPTIONS_PROJECTS'
export const SET_FILTERS_OPTIONS_PROJECT_ID = 'SET_FILTERS_OPTIONS_PROJECT_ID'
export const GET_ROOM_NOTES = 'GET_ROOM_NOTES'
